import React from 'react';
import MyRequestDetails from '../../user/myrequests/myrequestdetails.page';

const RequestDetailsAdminLayout = () => {
  return (
    <div className='admin-area-2'>
        <div className='page-content request-details-page'>
            <MyRequestDetails />
        </div>
    </div>
  );
};

export default RequestDetailsAdminLayout;